import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { downgradeComponent } from "@angular/upgrade/static";
import * as angular from "angular";

import { RelatoriosRoutingModule } from "./relatorio.routes";
import { ServicesModule } from "../services/services.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import {
  MatInputModule,
  MatButtonModule,
  MatIconModule,
  MatTooltipModule,
  MatDialogModule,
  MatChipsModule
} from "@angular/material";
import { RelatorioService } from "./services/relatorio.services";
import { ListarRelatorioComponent } from "./pages/listar/listar-relatorio.component";
import { ModalCriarComponent } from "./pages/criar/criar-relatorio.component";
import { ModalExcluirComponent } from "./pages/excluir/excluir-relatorio.component";
import { ModalEditarComponent } from "./pages/editar/editar-relatorio.component";
import { SlaDownloadComponent } from "./pages/sla-download/sla-download.component";

@NgModule({
  declarations: [
    ListarRelatorioComponent,
    ModalCriarComponent,
    ModalEditarComponent,
    ModalExcluirComponent,
    SlaDownloadComponent
  ],
  imports: [
    CommonModule,
    RelatoriosRoutingModule,
    ServicesModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatDialogModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    MatChipsModule
  ],
  providers: [RelatorioService],
  entryComponents: [
    ListarRelatorioComponent,
    ModalCriarComponent,
    ModalEditarComponent,
    ModalExcluirComponent,
    SlaDownloadComponent
  ]
})
export class RelatoriosModule {}

try {
  angular
    .module("mandaeApp")
    .directive(
      "appRelatorioListagem",
      downgradeComponent({ component: ListarRelatorioComponent })
    )
    .directive(
      "appRelatorioSlaDownload",
      downgradeComponent({ component: SlaDownloadComponent })
    );
} catch (e) {}
